import { render } from "./DeleteEleve.vue?vue&type=template&id=5c3750ca&scoped=true"
import script from "./DeleteEleve.vue?vue&type=script&lang=js"
export * from "./DeleteEleve.vue?vue&type=script&lang=js"

import "./DeleteEleve.vue?vue&type=style&index=0&id=5c3750ca&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c3750ca"]])

export default __exports__